<template>
    <div id="templates">
        <script type="text/x-template" id="template">
            <div class="scene"></div>
            <div class="thumbnail-info">
                <div class="description">Scene $</div>
            </div>

            <div class="preview-opacity-container" style="display: none">
                <span class="slider-name">Opacity</span>
                <input type="range" min="0" max="100" value="100" step="0.001" class="range_slider thumbnail-slider">
                <input type="text" class="range_value thumbnail_range" value="100" name="quantity" min="0" max="100"
                       placeholder="0">
            </div>
        </script>

        <script type="text/x-template" id="template-block-controls" class="template">
            <i class="material-icons drag-indicator">drag_indicator</i>

            <div class="controls-wrapper">
                <div class="blending-mode__label-container">
                    <i class="btn-blending-mode material-icons" data-tippy-content="Blending Mode">layers</i>
                    <i class="material-icons">expand_more</i>
                </div>
                <div class="blending-mode__items-container" style="display: none;">
                    <span data-id="0" class="--applied --border-bottom">Normal</span>

                    <span data-id="10">Darken</span>
                    <span data-id="11">Multiply</span>
                    <span data-id="12">Reflect</span>
                    <span data-id="13">Color Burn</span>
                    <span data-id="14" class="--border-bottom">Linear Burn</span>

                    <span data-id="20">Add</span>
                    <span data-id="21">Lighten</span>
                    <span data-id="22">Average</span>
                    <span data-id="23">Screen</span>
                    <span data-id="24">Color Dodge</span>
                    <span data-id="25" class="--border-bottom">Linear Dodge</span>

                    <span data-id="30">Overlay</span>
                    <span data-id="31">Soft Light</span>
                    <span data-id="32">Hard Light</span>
                    <span data-id="33">Vivid Light</span>
                    <span data-id="34">Linear Light</span>
                    <span data-id="35">Pin Light</span>
                    <span data-id="36" class="--border-bottom">Hard Mix</span>

                    <span data-id="40">Difference</span>
                    <span data-id="41">Exclusion</span>
                    <span data-id="42">Negation</span>
                    <span data-id="43" class="--border-bottom">Substract</span>

                    <span data-id="50">Hue</span>
                    <span data-id="51">Saturation</span>
                    <span data-id="52">Color</span>
                    <span data-id="53">Luminosity</span>
                </div>
                <i class="btn-reset-block material-icons" data-tippy-content="Reset">settings_backup_restore</i>
                <i class="btn-remove-block material-icons" data-tippy-content="Remove">highlight_off</i>
                <i class="toggle_arrow expand_options material-icons" data-tippy-content="Expand">expand_more</i>
                <i class="toggle_arrow collapse_options material-icons" style="display: none;" data-tippy-content="Collapse">expand_less</i>
                <div class="switch switch-container">
                    <input type="checkbox" />
                    <span class="slider round"></span>
                </div>
            </div>
        </script>

        <script type="text/x-template" id="template-lut">
            <li class="block look_block lut-block adjustment-block preview-based disabled">
                <div class="header-container edit_block_header drag_handle">
                    <label class="lookup_block_name name">Look block</label>
                </div>

                <div class="block_options">
                    <div class="lut-selector">
                        <div class="lut-selector__label-container">
                            <span class="selected-lut-name">Select...</span>
                            <i class="material-icons">expand_more</i>
                            <i class="btn-reset-selection material-icons" data-tippy-content="Remove selection">settings_backup_restore</i>
                        </div>
                        <div class="lut-selector__items-container"></div>
                    </div>

                    <div class="block-sliders-container">
                        <span class="slider-name">Opacity</span>
                        <input type="range" min="0" max="100" value="100" data-default-value="100" class="range_slider opacity_slider">
                        <input type="number" class="lookup_range_value range_value opacity-input" value="100" min="1" max="100">
                    </div>
                </div>
            </li>
        </script>

        <script type="text/x-template" id="template-ExposureV2" class="template">
            <li class="block edit_block exposure-block adjustment-block">
                <div class="header-container edit_block_header drag_handle">
                    <label class="lookup_block_name name">Exposure</label>
                </div>

                <div class="block_options">
                    <div class="block-sliders-container">
                        <span class="slider-name">Exposure</span>
                        <input type="range" min="-5" max="5" value="0" step="0.01" data-pass-index="0" class="range_slider exposure_slider adjustmentBlock-slider">
                        <div class="input-group --with-knob">
                            <input type="text" class="input-knob" />
                            <input type="number" class="range_value exposure_range adjustmentBlock-range" value="0" name="quantity" min="-5" max="5" step="0.01">
                        </div>
                    </div>
                </div>
            </li>
        </script>

        <script type="text/x-template" id="template-ContrastV2" class="template">
            <li class="block edit_block contrast-block adjustment-block">
                <div class="header-container edit_block_header drag_handle">
                    <label class="lookup_block_name name">Contrast</label>
                </div>

                <div class="block_options">
                    <div class="block-sliders-container">
                        <span class="slider-name">Contrast</span>
                        <input
                                type="range"
                                min="-1"
                                max="1"
                                value="0"
                                step="0.01"
                                data-pass-index="0"
                                class="range_slider contrast_slider adjustmentBlock-slider"
                        />
                        <div class="input-group --with-knob">
                            <input type="text" class="input-knob" />
                            <input type="number" class="range_value contrast_range adjustmentBlock-range" value="0" name="quantity" min="-1" max="1" step="0.01" />
                        </div>
                    </div>

                    <div class="block-sliders-container">
                        <span class="slider-name">Pivot</span>
                        <input
                                type="range"
                                min="0"
                                max="1"
                                value="0.435"
                                data-default-value="0.435"
                                step="0.001"
                                class="range_slider pivot_slider adjustmentBlock-slider"
                        />
                        <div class="input-group --with-knob">
                            <input type="text" class="input-knob" />
                            <input type="number" class="range_value pivot_range adjustmentBlock-range" value="0.435" data-default-value="0.435" name="quantity" min="0" max="1" step="0.001" />
                        </div>
                    </div>
                </div>
            </li>
        </script>

        <script type="text/x-template" id="template-custom-lut">
            <li class="block look_block custom-lut-block adjustment-block preview-based">
                <div class="header-container edit_block_header drag_handle">
                    <label class="lookup_block_name name">Custom LUT</label>
                </div>

                <div class="block_options">
                    <div class="custom-lut-buttons-container d-flex justify-end align-center mb-2">
                        <i class="btn-edit-custom-luts material-icons" data-tippy-content="LUTs Management">add_circle_outline</i>
                    </div>

                    <div class="block-option custom-lut-folder d-flex justify-space-between align-center mb-2">
                        <span>Custom LUT Folder</span>
                        <div class="control-selector mb-0" style="max-width: 50%;">
                            <div class="control-selector__label-container --disabled"
                                 style="width: initial; max-width: 100%; margin-right: initial; position: relative">
                                <span class="selected-control-name selected-custom-lut-folder-name">Select LUT folder</span>
                                <i class="material-icons">expand_more</i>
                                <div class="control-selector__items-container"
                                     style="display: none; min-width: 180px; right: 0; left: initial"></div>
                            </div>
                        </div>
                    </div>

                    <div class="block-option custom-lut d-flex justify-space-between align-center mb-2">
                        <span>Selected LUT</span>
                        <div class="lut-selector" style="max-width: 50%;">
                            <div class="lut-selector__label-container --disabled" style="max-width: 100%;">
                                <span class="selected-lut-name selected-custom-lut-name">None</span>
                                <i class="material-icons">expand_more</i>
                                <div class="lut-selector__items-container"
                                     style="display: none; min-width: 180px; right: 0; left: initial"></div>
                            </div>
                        </div>
                    </div>

                    <div class="block-sliders-container --disabled">
                        <span class="slider-name">Opacity</span>
                        <input type="range" min="0" max="100" value="100" class="range_slider opacity_slider">
                        <input type="number" class="lookup_range_value range_value opacity-input" value="100" min="1"
                               max="100">
                    </div>
                </div>
            </li>
        </script>

        <script type="text/x-template" id="template-WhiteBalance" class="template">
            <li class="block edit_block white-balance-block adjustment-block">
                <div class="header-container edit_block_header drag_handle">
                    <label class="lookup_block_name name">White balance</label>
                </div>

                <div class="block_options">
                    <div class="block-sliders-container">
                        <span class="slider-name">White balance</span>
                        <input type="range" min="-4000" max="4000" value="0" step="1" data-pass-index="0" class="range_slider white_balance_slider adjustmentBlock-slider">
                        <div class="input-group --with-knob">
                            <input type="text" class="input-knob" />
                            <input type="number" class="range_value white_balance_range adjustmentBlock-range" value="0" name="quantity" min="-4000" max="4000" step="1">
                        </div>
                    </div>

                    <div class="block-sliders-container">
                        <span class="slider-name">Tint</span>
                        <input type="range" min="-100" max="100" value="0" step="1" data-pass-index="1" class="range_slider tint_slider adjustmentBlock-slider">
                        <div class="input-group --with-knob">
                            <input type="text" class="input-knob" />
                            <input type="number" class="range_value tint_range adjustmentBlock-range" value="0" name="quantity" min="-100" max="100" step="1">
                        </div>
                    </div>
                </div>
            </li>
        </script>


<!--        <lutPreviews />-->
<!--        <blocksControls />-->
<!--        <lut />-->
<!--        <ContrastV2 />-->
<!--        <CustomLUT />-->
<!--        <ExposureV2 />-->
<!--        <WhiteBalance />-->
    </div>
</template>

<script>
// import lutPreviews from '@/views/templates/lutPreviews';
// import blocksControls from '@/views/templates/blocks/includes/controls';
// import lut from '@/views/templates/blocks/lut';
// import ContrastV2 from '@/views/templates/blocks/ContrastV2';
// import CustomLUT from '@/views/templates/blocks/customLut';
// import ExposureV2 from '@/views/templates/blocks/ExposureV2';
// import WhiteBalance from '@/views/templates/blocks/whiteBalance';

export default {
    name: 'Templates',
    components: {
        // lutPreviews,
        // blocksControls,
        // lut,
        // ContrastV2,
        // CustomLUT,
        // ExposureV2,
        // WhiteBalance,
    },

    async mounted() {
        await this.$store.dispatch('App/setTemplatesLoaded');
    }
};
</script>
